import styled from 'styled-components';
import { Spinner } from '../../spinners/Spinner';

export const TableLoader = styled(Spinner)`
  position: absolute;
  top: 2px;
  right: 2px;
`;
